export default "__VITE_ASSET__BSIFuwAp__"